@if (isOpen()) {
  <!-- Backdrop -->
  <div
    [class]="backdropClasses()"
    (click)="onBackdropClick()"
    (keydown)="onKeyDown($event)"
    tabindex="-1"
    role="presentation"
  ></div>

  <!-- Modal Container -->
  <div [class]="modalContainerClasses()">
    <div
      [class]="modalClasses() + ' ' + modalSizeClasses()"
      class="flex flex-col max-h-[85vh]"
      role="dialog"
      [attr.aria-modal]="true"
      [attr.aria-labelledby]="ariaLabelledBy() || (title() ? 'modal-title' : null)"
      [attr.aria-describedby]="ariaDescribedBy()"
      cdkTrapFocus
      cdkTrapFocusAutoCapture
      (keydown)="onKeyDown($event)"
    >
      <!-- Header (fixed, never scrolls) -->
      @if (title() || showCloseButton()) {
        <div [class]="headerClasses()" class="flex-shrink-0">
          <div class="flex-1 min-w-0">
            @if (title()) {
              <h2 [id]="ariaLabelledBy() || 'modal-title'" [class]="titleClasses()">
                {{ title() }}
              </h2>
            }
            @if (subtitle()) {
              <p [class]="subtitleClasses()">{{ subtitle() }}</p>
            }
          </div>

          @if (showCloseButton()) {
            <button
              type="button"
              [class]="closeButtonClasses()"
              (click)="close()"
              aria-label="Close dialog"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          }
        </div>
      }

      <!-- Content area (scrollable, flex-1 to fill remaining space) -->
      <div class="px-6 py-5 flex-1 overflow-y-auto">
        <ng-content></ng-content>
      </div>

      <!-- Footer slot (fixed at bottom, never scrolls) -->
      <ng-content select="ui-modal-footer"></ng-content>
    </div>
  </div>
}
